import { useBrowsingWorkspaceRoutes } from 'v5/core/app-scope/useBrowsingWorkspaceRoutes';
import { resourceCard } from 'v5/patterns/resource/resourceReferenceSource';
import { useResourcePins } from 'v5/features/resources/useResourcePins';
import type { ResourcePickerSource } from 'v5/patterns/resource-picker/ResourcePickerResults';
import type { WithServices } from 'v5/platform/ts/services';
import type { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';

/**
 * A picker's resources as the app shows them elsewhere: the card of a referenced resource, its
 * page in the browsing scope (as the resource lists link it), its pictures from the v1 store.
 */
export function useResourcePickerSource(
  services: WithServices<[WithAppScopeService]>['services']
): ResourcePickerSource {
  const routes = useBrowsingWorkspaceRoutes(services);
  return {
    cardOf: resourceCard,
    pageHrefOf: resource => routes.contacts.detail(resource.id),
    usePins: useResourcePins
  };
}
